import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "app/auth/base";
import { closeLoading, openLoading } from "app/store/trackingApp/loadingSlice";
import { openToast } from "app/store/trackingApp/toastSlice";
import { openModalError } from "app/store/trackingApp/modalErrorSlice";

export const getMenus = createAsyncThunk(
  "acessosApp/menus/getMenus",
  async (data: object, { dispatch }) => {
    let response;
    let responseAllViews;
    let responseAllMenus;
    dispatch(openLoading());
    try {
      response = await API.get("/menu", {
        params: data,
      });
      responseAllViews = await API.get("/menu-tela", {
        params: { pagina: 1, itensPorPagina: 5000 },
      });
      responseAllMenus = await API.get("/menu", {
        params: { pagina: 1, itensPorPagina: 5000 },
      });
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível buscar os menus!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    dispatch(closeLoading());
    return {
      responseData: response.data,
      responseAllViewsData: responseAllViews.data,
      responseAllMenusData: responseAllMenus.data,
    };
  }
);

export const saveMenu = createAsyncThunk(
  "acessosApp/menus/saveMenu",
  async (data: object, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    try {
      await API.post("/menu", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Menu cadastrado",
        })
      );
      dispatch(getMenus(requestGetParams.acessosApp.menus.requestGetParams));
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível cadastrar o menu!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    return {};
  }
);

export const editMenu = createAsyncThunk(
  "acessosApp/menus/editMenu",
  async (data: object, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    try {
      await API.put("/menu", data);
      dispatch(
        openToast({
          severity: "success",
          title: "Menu editado",
        })
      );
      dispatch(getMenus(requestGetParams.acessosApp.menus.requestGetParams));
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível editar o menu!",
          text: "Se certifique que os dados digitados estão corretos",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    return {};
  }
);

export const deleteMenu = createAsyncThunk(
  "acessosApp/menus/deleteMenu",
  async (data: any, { dispatch, getState }) => {
    const requestGetParams: any = getState();
    const { idMenu } = data;
    try {
      await API.delete(`/menu?idMenu=${idMenu}`);
      dispatch(
        openToast({
          severity: "success",
          title: "Menu removido",
        })
      );
      dispatch(getMenus(requestGetParams.acessosApp.menus.requestGetParams));
    } catch (err: any) {
      dispatch(
        openModalError({
          title: "Não foi possível remover o menu!",
          text: "Se certifique que a solicitação está correta",
          btnLabel: "Voltar",
        })
      );
      console.error(err.response);
    }
    return {};
  }
);
